import request from '@/utils/request'
import qs from 'qs'

// 获取文章详细信息
const cms_article_info = (params) => {
  return request({
    url: '/portal/cms/article/info',
    method: 'get',
    params
  })
}

// 获取文章分页数据
const cms_article_list = (params) => {
  return request({
    url: '/portal/cms/article/list',
    method: 'get',
    params
  })
}

// 获取某一个code下面的第一篇文章
const cms_article_first = (params) => {
  return request({
    url: '/portal/cms/article/first',
    method: 'get',
    params
  })
}

// 根据文章code获取文章信息
const cms_code_article_info = (params) => {
  return request({
    url: '/portal/cms/code/article/info',
    method: 'get',
    params
  })
}

// 获取文章焦点列表
const cms_article_focuses = (params) => {
  return request({
    url: '/portal/cms/article/focuses',
    method: 'get',
    params
  })
}

// 栏目信息-批量获取指定个数子集栏目以及第一个子集栏目的数据
const cms_node_subsets = (data) => {
  return request({
    url: '/portal/cms/batch/node/subsets',
    method: 'post',
    data
  })
}

// 栏目信息-批量获取指定栏目信息以及上下级栏目数据
const cms_node_data = (data) => {
  return request({
    url: '/portal/cms/batch/node/data',
    method: 'post',
    data
  })
}

// 栏目信息-批量获取指定栏目信息以及栏目数据
const cms_batch_nodes = (data) => {
  return request({
    url: '/portal/cms/batch/nodes',
    method: 'post',
    data
  })
}

// 栏目信息-根据code获取单个栏目信息
const cms_nodeCodeInfo = (params) => {
  return request({
    url: '/portal/cms/nodeCodeInfo',
    method: 'get',
    params
  })
}

// 获取站点基本信息
const cms_site_info = (params) => {
  return request({
    url: '/portal/cms/site/info',
    method: 'get',
    params
  })
}

// 首页-项目公告列表
const project_home = (params) => {
  return request({
    url: '/portal/project/home',
    method: 'get',
    params
  })
}

// 公告-项目详情
const project_info = (params) => {
  return request({
    url: '/portal/project/info',
    method: 'get',
    params
  })
}

// 项目公告列表
const project_list = (params) => {
  return request({
    url: '/portal/project/list',
    method: 'get',
    params
  })
}

// 获取站点子集区域信息
const loc_getSiteSubset = (params) => {
  return request({
    url: '/portal/loc/getSiteSubset',
    method: 'get',
    params
  })
}

// 竞拍大厅列表
const auction_hall = (params) => {
  return request({
    url: '/portal/auction/hall',
    method: 'get',
    params
  })
}

// 竞拍-项目详情
const auction_info = (params) => {
  return request({
    url: '/portal/auction/info',
    method: 'get',
    params
  })
}

// 竞拍-检查公告
const auction_checkNotice = (params) => {
  return request({
    url: '/portal/auction/checkNotice',
    method: 'get',
    params
  })
}

// 首页-竞拍列表
const auction_home = (params) => {
  return request({
    url: '/portal/auction/home',
    method: 'get',
    params
  })
}

// 数据大屏
// 公告列表
const data_notice = (params) => {
  return request({
    url: '/portal/data/notice/list',
    method: 'get',
    params
  })
}

// 排名
const data_ranking = (params) => {
  return request({
    url: '/portal/data/ranking',
    method: 'get',
    params
  })
}

// 汇总统计
const data_statis = (params) => {
  return request({
    url: '/portal/data/statis',
    method: 'get',
    params
  })
}

// 广告
const cms_adverts = (params) => {
  return request({
    url: '/portal/cms/adverts',
    method: 'get',
    params
  })
}

// 文件列表
const cms_files = (params) => {
  return request({
    url: '/portal/cms/files',
    method: 'get',
    params
  })
}

// 项目推荐
const auction_recommend = (params) => {
  return request({
    url: '/portal/auction/recommend',
    method: 'get',
    params
  })
}

// 优质项目
const merchant_recommend = (params) => {
  return request({
    url: '/portal/merchant/recommend',
    method: 'get',
    params
  })
}

// 搜索竞拍项目
const search_auctions = (params) => {
  return request({
    url: '/portal/search/auctions',
    method: 'get',
    params
  })
}

// 交易大厅-项目列表
const portal_project_tradingHall = (params) => {
  return request({
    url: '/portal/project/tradingHall',
    method: 'get',
    params
  })
}

const portal_project_apply_init = (params) => {
  return request({
    url: '/portal/project/apply/init',
    method: 'get',
    params
  })
}

// 交易大厅-招商推介列表
const portal_merchant_List = (params) => {
  return request({
    url: '/portal/merchant/list',
    method: 'get',
    params
  })
}

// 服务商列表
const service_merchant_list = (params) => {
  return request({
    url: '/portal/facilitator/list',
    method: 'get',
    params
  })
}
// 字典列表
const portal_cms_dicts = (params) => {
  return request({
    url: '/portal/cms/dicts',
    method: 'get',
    params
  })
}
// 交易大厅-项目详情
const portal_auction_info2 = (params) => {
  return request({
    url: '/portal/auction/info2',
    method: 'get',
    params
  })
}

// 招商推介-招商详情
const portal_merchant_info = (params) => {
  return request({
    url: '/portal/merchant/info',
    method: 'get',
    params
  })
}

// 服务商-服务商详情
const portal_facilitator_info = (params) => {
  return request({
    url: '/portal/facilitator/info',
    method: 'get',
    params
  })
}

// 报名（除网络竞价的项目）
const portal_project_apply = (data) => {
  return request({
    url: '/portal/project/apply',
    method: 'post',
    data
  })
}

// 获取项目公告（详情页）
const portal_project_notices = (params) => {
  return request({
    url: '/portal/project/notices',
    method: 'get',
    params
  })
}

// 我的报名列表
const portal_user_applyList = (params) => {
  return request({
    url: '/portal/user/applyList',
    method: 'get',
    params
  })
}

// 下载附件
const portal_upload_download = (params) => {
  return request({
    url: '/portal/upload/download',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

// 交易类型分析V2
const data_v2_analysis = (params) => {
  return request({
    url: '/portal/data/v2/kind/analysis',
    method: 'get',
    params
  })
}

// 交易类型分析V2
const portal_data_v2_subject = (params) => {
  return request({
    url: '/portal/data/v2/subject',
    method: 'get',
    params
  })
}

// 成交公告
const data_v2_notice = (params) => {
  return request({
    url: '/portal/data/v2/notice',
    method: 'get',
    params
  })
}

// 交易排名V2
const data_v2_ranking = (params) => {
  return request({
    url: '/portal/data/v2/ranking',
    method: 'get',
    params
  })
}

// 竞价率及溢价率V2
const data_v2_rate = (params) => {
  return request({
    url: '/portal/data/v2/rate',
    method: 'get',
    params
  })
}

// 数据概况统计接口V2
const data_v2_statis = (params) => {
  return request({
    url: '/portal/data/v2/statis',
    method: 'get',
    params
  })
}

// 地图信息接口
const data_v2_maps = (data) => {
  return request({
    url: '/portal/data/v2/maps',
    method: 'post',
    data: qs.stringify(data, { arrayFormat: 'repeat' }),
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    }
  })
}

export {
  data_v2_maps,
  data_v2_analysis,
  portal_data_v2_subject,
  data_v2_notice,
  data_v2_ranking,
  data_v2_rate,
  data_v2_statis,
  portal_upload_download,
  portal_user_applyList,
  portal_project_notices,
  portal_project_apply,
  portal_auction_info2,
  portal_project_apply_init,
  portal_facilitator_info,
  portal_project_tradingHall,
  search_auctions,
  auction_recommend,
  auction_home,
  cms_article_info,
  cms_code_article_info,
  cms_article_list,
  cms_article_first,
  cms_site_info,
  cms_node_subsets,
  cms_node_data,
  cms_batch_nodes,
  project_home,
  project_info,
  project_list,
  loc_getSiteSubset,
  auction_hall,
  auction_info,
  auction_checkNotice,
  data_notice,
  data_ranking,
  data_statis,
  cms_article_focuses,
  cms_adverts,
  cms_files,
  cms_nodeCodeInfo,
  service_merchant_list,
  portal_cms_dicts,
  portal_merchant_List,
  portal_merchant_info,
  merchant_recommend

}
